<script lang="ts" setup>
import { vOnClickOutside } from '@vueuse/components'

const route = useRoute()
const router = useRouter()

const { loadLayout, layoutData } = useLayout()
await loadLayout()

useServerError(!layoutData?.value?.mainMenu)

const {
  open,
  showSubmenu,
  closeNavigation,
  // mouseOver,
  // mouseOut,
  keypress,
  closeSubnavigation,
  toggleSubnavigation,
} = useNavigation()

watch(() => route.query || route.path, () => {
  if (open.value) {
    closeNavigation()
    const mainEl = document.getElementById('main')
    if (mainEl) {
      mainEl.focus()
    }
  }
})

onMounted(() => {
  document.addEventListener('keydown', keypress)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', keypress)
  closeNavigation()
})

router.beforeEach(() => {
  showSubmenu.value = null
})
</script>

<template>
  <nav
    v-if="layoutData?.mainMenu?.Items?.length"
    id="navigation"
    class="navigation"
    :class="{ 'navigation--open': open }"
    :aria-label="$t('Main navigation')"
  >
    <NavigationToggle />

    <div
      id="navigation"
      class="navigation__panel"
    >
      <NavigationHeader />

      <div
        class="navigation__content"
      >
        <slot name="navigation_before" />

        <ul class="navigation__list">
          <template v-for="(item, index) in layoutData?.mainMenu?.Items">
            <li
              v-if="item?.Title && item?.Link && item?.ShowInNavigation"
              :key="index"
              v-on-click-outside="() => closeSubnavigation(index)"
              class="navigation__item"
            >
              <button
                v-if="item.ShowSubNavigation"
                type="button"
                class="navigation__link"
                aria-haspopup="true"
                :aria-expanded="showSubmenu === index ? 'true' : 'false'"
                :style="`--color: ${item.Color}`"
                @click="toggleSubnavigation(index)"
              >
                <span>{{ item.Title }}</span>
                <Icon name="icon:arrow" />
              </button>
              <AppLink
                v-else
                :to="item.Link"
                class="navigation__link"
                :style="`--color: ${item.Color}`"
              >
                <span>{{ item.Title }}</span>
              </AppLink>

              <NavigationLevel2
                v-if="item?.Subnavigation && item.ShowSubNavigation"
                :item="item"
                :index="index"
              />
            </li>
          </template>
        </ul>
        <!-- <slot name="navigation_after" /> -->

        <NavigationExtraLinks />
      </div>
    </div>
  </nav>
</template>

<style>
@import url("~layers/app/components/Navigation/index.css");
</style>
